var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/image-msg-item.html');
/*require('./../../style/msg/image-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');
var util = require('./../../global/utils');

var ImageMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template,
      onImageClick: function () {
      }
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;

  /*(function (self) {
   self._element.find('.im-msg-main .im-msg-send-status').click(function () {
   dispatcher.dispatch({
   type: ActionType.MSG_RESEND_APPLY,
   data: self._data.msg
   });
   });
   })(this);*/
};
ImageMsgItem.prototype = Object.create(BaseMsgItem.prototype);
ImageMsgItem.prototype.renderContent = function () {
  var self = this;
  var $content = this._element.find('.im-msg-content');
  $content.click(function () {
    if (self._data.msg.msg_id) {
      self._options.onImageClick();
    }
  });
  var msgcontent = this._data.msg.content;
  var options = {
    minsize: 50,
    maxsize: 250,
    image_width: msgcontent.image_width,
    image_height: msgcontent.image_height,
    url: msgcontent.url
  };
  var imgParams = util.getImgParams(options);
  $content.css({
    'height': imgParams.height + 'px',
    'width': imgParams.width + 'px',
    'background-size': imgParams.background_size,
    'background-image': 'url(' + imgParams.url + ')',
    'background-repeat': 'no-repeat'
  });
};

module.exports = ImageMsgItem;
